export const QBR_STATUS = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  DEACTIVATED: 'DEACTIVATED',
  SUSPENDED: 'SUSPENDED',
  INVALID_ABN: 'INVALID_ABN',
  INVALID_NAME: 'INVALID_NAME',
  INVALID_MOBILE: 'INVALID_MOBILE',
  INVALID_EMAIL: 'INVALID_EMAIL',
  INVALID_INPUT: 'INVALID_INPUT',
  INVALID_PROMO_CODE: 'INVALID_PROMO_CODE',
  EMAIL_ALREADY_REGISTERED: 'EMAIL_ALREADY_REGISTERED',
  ABN_ALREADY_REGISTERED: 'ABN_ALREADY_REGISTERED',
  ENTITY_ALREADY_EXISTS: 'ENTITY_ALREADY_EXISTS',
  NO_ACCOUNT: 'NO_ACCOUNT',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;
